const React = require("react");
const Layout = require("./src/components/Layout").default;

exports.wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
);

// https://github.com/gatsbyjs/gatsby/issues/11898#issuecomment-465706313
exports.shouldUpdateScroll = () => false;
